import { render, staticRenderFns } from "./rework_items.vue?vue&type=template&id=7bd8b152"
import script from "./rework_items.vue?vue&type=script&lang=js"
export * from "./rework_items.vue?vue&type=script&lang=js"
import style0 from "./rework_items.vue?vue&type=style&index=0&id=7bd8b152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports